import React from 'react';

import { Numeric } from '@swyftx/aviary/atoms/Typography';

import { formatCurrency } from '@shared/utils';

import { observer } from 'mobx-react-lite';
import { useMarginPositionDetails } from 'src/lib/margin/hooks/positions';

type Props = {
  positionId?: string;
};

const MarginPositionsTableCurrentPrice: React.FC<Props> = observer(({ positionId }) => {
  const { currentPrice } = useMarginPositionDetails({ positionId });

  return <Numeric>{formatCurrency(currentPrice)}</Numeric>;
});

export { MarginPositionsTableCurrentPrice };
